import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';
import ProductDetail from '../components/products/ProductDetail';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProductDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try { setLoading(true); const res = await axios.get(`${API}/products/${id}`); setProduct(res.data); }
      catch (err) { setError('Product not found'); }
      finally { setLoading(false); }
    };
    fetchProduct();
  }, [id]);

  if (loading) return (
    <div className="min-h-screen bg-[#FEFCF9] flex items-center justify-center">
      <div className="inline-block w-10 h-10 border-2 border-[#E8DCC8] border-t-[#C4A265] rounded-full animate-spin"></div>
    </div>
  );

  if (error || !product) return (
    <div className="min-h-screen bg-[#FEFCF9] flex flex-col items-center justify-center">
      <p className="text-red-500 text-lg mb-4">{error || 'Product not found'}</p>
      <button onClick={() => navigate('/shop')} className="text-[#C4A265] hover:text-[#A0822E] font-semibold tracking-wider uppercase text-sm">Back to Shop</button>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#FEFCF9]">
      <div className="bg-[#F5EFE6] py-4 border-b border-[#E8DCC8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <button onClick={() => navigate('/shop')} className="flex items-center space-x-2 text-[#7A6B5D] hover:text-[#C4A265] transition-colors">
            <ArrowLeft className="w-5 h-5" />
            <span className="text-sm tracking-wider uppercase">Back to Shop</span>
          </button>
        </div>
      </div>
      <ProductDetail product={product} />
    </div>
  );
};

export default ProductDetailPage;
